import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'antd'
import { useHistory } from 'react-router-dom'

const SECTIONS = ['Morning', 'Noon', 'Night']
const HOURS = ['9', '12', '19']

const CurrentPill = ({ currentPill, images }) => {
  const { name, numPills, img, width, days } = currentPill
  const imageSrc = images[img] || '/images/nothing.png'
  const imageWidth = width || "256"
  const imageContainerWidth = /^\d+$/.test(String(imageWidth)) ? `${imageWidth}px` : imageWidth
  const [loadedImageSrc, setLoadedImageSrc] = useState(null)

  const dayMessage =
    days === 'MWF'
      ? 'in sections for Monday, Wednesday, and Friday ONLY'
      : 'in each section of each day';

  useEffect(() => {
    setLoadedImageSrc(null)
  }, [imageSrc])

  return (
    <div className="block tc">
      <h2 className="mv4">Put {numPills} {name} <br/> {dayMessage}</h2>
      <div style={{ height: 256, width: imageContainerWidth, margin: '0 auto' }}>
        <img
          key={imageSrc}
          alt={name}
          src={imageSrc}
          height="256"
          width={imageWidth}
          onLoad={() => setLoadedImageSrc(imageSrc)}
          style={{ visibility: loadedImageSrc === imageSrc ? 'visible' : 'hidden' }}
        />
      </div>
    </div>
  )
}

const Tutorial = ({ allPills, images, showTutorialModal, setShowTutorialModal, setCurrentTab }) => {
  const history = useHistory()

  const [currentSection, setCurrentSection] = useState(0)
  const [groupedPills, setGroupedPills] = useState([[], [], []])
  const [pillIndex, setPillIndex] = useState(-1)
  const [showIntro, setShowIntro] = useState(true)

  useEffect(() => {
    const groups = { '9': [], '12': [], '19': [] }

    allPills.forEach(pill => {
      pill.hour.split(',').forEach(hour => {
        if (groups[hour] && pill.numPills !== 0) groups[hour].push(pill)
      })
    })

    const nextGrouped = HOURS.map(h => [...groups[h]])
    const imageSources = new Set(nextGrouped.flat().map(pill => images[pill.img] || '/images/nothing.png'))

    imageSources.forEach(src => {
      const pillImage = new Image()
      pillImage.src = src
    })

    setGroupedPills(nextGrouped)
    setCurrentSection(0)
    setShowIntro(true)
    setPillIndex(nextGrouped[0] ? nextGrouped[0].length - 1 : -1)
  }, [allPills, images])

  const getLastIndex = index => (groupedPills[index] ? groupedPills[index].length - 1 : -1)

  const goToSection = index => {
    setCurrentSection(index)
    setShowIntro(true)
    setPillIndex(getLastIndex(index))
  }

  const handleNext = () => {
    const currentPills = groupedPills[currentSection] || []
    if (showIntro) {
      if (currentPills.length === 0) {
        if (currentSection < SECTIONS.length - 1) {
          goToSection(currentSection + 1)
        } else {
          setShowIntro(false)
          setPillIndex(-1)
        }
      } else {
        setShowIntro(false)
      }
      return
    }

    if (pillIndex > 0) {
      setPillIndex(pillIndex - 1)
      return
    }

    if (currentSection < SECTIONS.length - 1) {
      goToSection(currentSection + 1)
    } else {
      setShowIntro(false)
      setPillIndex(-1)
    }
  }

  const handleBack = () => {
    if (showIntro) {
      if (currentSection === 0) return
      const prevSection = currentSection - 1
      const prevLastIndex = getLastIndex(prevSection)
      setCurrentSection(prevSection)
      if (prevLastIndex >= 0) {
        setShowIntro(false)
        setPillIndex(prevLastIndex)
      } else {
        setShowIntro(true)
        setPillIndex(-1)
      }
      return
    }

    const lastIndex = getLastIndex(currentSection)
    if (pillIndex < lastIndex) {
      setPillIndex(pillIndex + 1)
    } else {
      setShowIntro(true)
    }
  }

  const cancelHandler = () => {
    setShowTutorialModal(false)
    setCurrentTab("all pills")
    history.push('/all-pills')
  }

  const currentPills = groupedPills[currentSection] || []
  const currentPill = pillIndex >= 0 ? currentPills[pillIndex] : null
  const isBackDisabled = showIntro && currentSection === 0
  const isFinished = !showIntro && !currentPill

  return (<Modal
    title="Fill Pill Box"
    centered={true}
    open={showTutorialModal}
    maskClosable={false}
    keyboard={false}
    onOk={isFinished ? cancelHandler : handleNext}
    okText={isFinished ? "Finish" : "Next"}
    onCancel={cancelHandler}
    footer={[
      <Button key="back" disabled={isBackDisabled} onClick={handleBack}>
        Go Back
      </Button>,
      <Button key="next" type="primary" onClick={isFinished ? cancelHandler : handleNext}>
        {isFinished ? "Finish" : "Next"}
      </Button>,
    ]}
  >
    {!showIntro ? (
        <div className="block justify-center p-4 mh4 tc">
            <h1>{currentPill ? SECTIONS[currentSection] : "You're finished for this week!"}</h1>
            {currentPill && (
                <CurrentPill currentPill={currentPill} images={images} />
            )}
        </div>
    ) : (<div className="block tc">
            <h2>Let's fill the <br/><h1 className="b">{SECTIONS[currentSection]}</h1> pill box sections. Click Next.</h2>
        </div>) }
</Modal>)
}

export default Tutorial
